import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { scrollToSection } from "@/lib/api";
import { useSiteContent } from "@/lib/content";

export const Footer = () => {
  const c = useSiteContent();
  return (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[var(--ekal-bg)] px-4 sm:px-8 lg:px-16 py-12">
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
      <div>
        <p className="font-heading font-extrabold uppercase tracking-tight text-3xl">
          Ekal <span className="text-[var(--ekal-accent)]">Sports</span> Media
        </p>
        <p className="mt-2 text-[10px] font-mono uppercase tracking-[0.3em] text-slate-500">
          {c.footer_tagline}
        </p>
        <a
          href="https://instagram.com/ekalsportsmedia"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="mt-4 inline-flex items-center gap-2.5 text-[11px] font-mono uppercase tracking-[0.2em] text-slate-400 hover:text-white transition-colors"
        >
          <Instagram size={15} className="text-[var(--ekal-accent)]" />
          Ekal Sports Media
        </a>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-3">
        {(c.nav_links || [])
          .filter((l) => l.visible !== false)
          .map((l) => (
            <button
              key={l.target}
              data-testid={`footer-nav-${l.target.replace("#", "")}`}
              onClick={() => scrollToSection(l.target)}
              className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-400 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-400 hover:text-white transition-colors"
        >
          Admin Portal
        </Link>
      </div>
    </div>
    <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
      <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-slate-600">
        © 2026 Ekal Sports Media — All frames reserved
      </p>
      <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-slate-600">
        40.7128° N / 74.0060° W — Field Level
      </p>
    </div>
  </footer>
  );
};
